export enum BenefitsList {
  One_Twenty_Five_MEDICAL = '125_medical',
  One_Twenty_Five_VISION = '125_vision',
  One_Twenty_Five_DENTAL = '125_dental',
  One_Twenty_Five_Disability = '125_disability',
  One_Twenty_Five_Accident = '125_accident',
  One_Twenty_Five_Cancer = '125_cancer',
  One_Twenty_Five_Critical_Illness = '125_critical_illness',
  One_Twenty_Five_Hospital = '125_hospital',
  One_Twenty_Five_Life = '125_life',
  One_Twenty_Five_Medical_Other = '125_medical_other',
  Four_O_One_K = '401k',
  Four_O_Three_B = '403b',
  Four_Five_Seven = '457',
  Roth_Four_O_One_K = 'roth_401k',
  Roth_Four_O_Three_B = 'roth_403b',
  Roth_Four_Five_Seven = 'roth_457',
  Fsa_Medical = 'fsa_medical',
  Fsa_Dependent_Care = 'fsa_dependent_care',
  HSA = 'hsa',
  Simple_IRA = 'simple_ira',
}

export enum BenefitPeriod {
  MONTHLY = 'Monthly',
  NONE = 'None',
}

export enum BenefitLevel {
  COMPANY = 'Company',
  EMPLOYEE = 'Employee',
}
export enum IntegratedBenefitType {
  SIMPLY_INSURED = 'simply_insured',
  NEXT_INSURANCE = 'next_insurance',
  GUIDELINE = 'guideline',
}

export interface BenefitOptions {
  value: number;
  key?: string;
  label: string;
}

export enum BenefitType {
  INTEGRATED = 'Integrated',
  MANUAL = 'Manual',
}

export interface BenefitData {
  id: number;
  benefitType: BenefitsList;
  period: BenefitPeriod;
  description: string;
  companyContributionAmount: number;
  employeeContributionAmount: number;
  companyContributionPercent: number;
  employeeContributionPercent: number;
  effectiveEnd: string;
  effectiveStart: string;
  level: BenefitLevel;
  createdAt: string;
  updatedAt: string;
}
export interface EmployeeBenefitsResponse {
  id: number;
  companyContributionAmount: number;
  companyContributionPercent: number;
  employeeContributionAmount: number;
  employeeContributionPercent: number;
  description: string;
  effectiveStart: string;
  effectiveEnd: string;
  checkhqEmployeeBenefitId: string;
  benefit: BenefitData;
}

// the interface IBenefitListResponse will be the array of benefitsData
export interface IBenefitListResponse {
  benefits: BenefitData[];
}
